import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";

export default class DepService {
    static async getUser(productId, msisdn) {
        const response = await axios.post(`${environmentConfig.depHost}/get-user-via-msisdn`, {
            msisdn: msisdn,
            productId,
        })
        return response.data;
    }

    static async decryptMsisdnV2(encryptedMsisdn) {
        const response = await axios.post(`${environmentConfig.depHost}/decrypt-msisdn/v2`, {
            encryptedMsisdn,
        }, { timeout: 8000 })
        return response.data;
    }

    static async trackUserLogin(msisdn, productId, service) {
        return await axios.post(`${environmentConfig.depHost}/track-user-login`, {
            productId: productId,
            msisdn: msisdn,
            serviceId: service === `daily` ? 6 : 7,
            isWeb: true,
        })
    }
}
